import axios from "axios";
import {
    API_USER_get_user_from_id, API_USER_login, API_USER_get_my_profile, API_USER_registration, API_USER_get_my_diamond, API_USER_get_my_rating,
    API_USER_get_my_role, API_USER_put_my_profile, API_USER_whatLectureNow, API_USER_learnings_myBuyLectures, API_USER_learnings_byLecture, API_USER_learnings_payTask, API_USER_get_my_task,
    API_USER_get_all_user, API_USER_profileData, API_USER_get_id_rating, API_USER_learnings_myTaskMineKlava, API_USER_learnings_TasksMineKlava, API_USER_learnings_payTaskMineKlava,
    API_USER_learnings_doneTaskWeb, API_USER_buyLevel, API_USER_search, API_USER_admin, API_USER_getLeaderboard, API_USER_getLeadersHistory, API_USER_getTop3Leaders, API_USER_getMonthStats,
    API_USER_learnings_doneTaskWebNotPay, USER_addres, API_USER_getMinecraftTasksStats,
    API_ADMIN_access_check, API_ADMIN_profiles_bulk
} from './API';
import { jwtDecode } from 'jwt-decode';
import logger from '../utils/logger';
export default class UserService {

    // Регистрация
    static async registration(user, printEror) {
        try {
            const response = await axios.post(API_USER_registration, {
                'firstName': user.username,
                'password': user.password,
                'email': user.email
            });

            if (response.data.message === 'Пользователь создан') {
                return true; // Возвращаем true при успешной регистрации
            } else if (response.data.message === 'Аккаунт с таким email зарегистрирован') {
                printEror('Аккаунт с таким email зарегистрирован');
                return false; // Возвращаем false при ошибке
            }
        } catch (error) {
            logger.log(error);
            if (error.response.status === 401) {
                printEror(error.response.data.message);
            }
            return false; // Возвращаем false в случае ошибки
        }
    }

    // логинимся
    static login = async (user, redirect, printEror) => {

        axios.post(API_USER_login, {
            'password': user.password,
            'email': user.email
        })
            .then(function (response) {
                logger.log('ОТВЕТ = ');
                logger.log(response);

                localStorage.setItem('Authorization', response.data.token) // добавляем токен в локал сторедж
                // refresh нужен для тихого продления сессии (см. API/tokenRenew.js).
                // Сервер кладёт его и в httpOnly-cookie, но в localStorage он
                // выручает сессии, где cookie не дошла.
                if (response.data.refreshToken) {
                    localStorage.setItem('refreshToken', response.data.refreshToken)
                }
                redirect()
                return 'Успех'
            })
            .catch(function (error) {
                logger.log(error);
                if (error.response.status == 401) {
                    printEror(error.response.data.message)
                }
            })
    }

    // логинимся
    static loginReg = async (user) => {
        try {
            const response = await axios.post(API_USER_login, {
                'password': user.password,
                'email': user.email
            });
            localStorage.setItem('Authorization', response.data.token); // добавляем токен в локал сторедж
            // refresh — для тихого продления сессии (API/tokenRenew.js)
            if (response.data.refreshToken) {
                localStorage.setItem('refreshToken', response.data.refreshToken);
            }
            return response.data; // Возвращаем данные ответа
        } catch (error) {
            logger.log(error);
            throw error; // Пробрасываем ошибку, чтобы ее можно было обработать
        }
    }




    // получить данные моего профиля
    static getMyProfile = async () => {
        const response = await axios.get(API_USER_get_my_profile, {
            headers: {
                'Authorization': localStorage.getItem('Authorization') //the token is a variable which holds the token
            }
        })
        return await response.data.data
    }

    // Проверить, есть ли у текущего пользователя доступ к админ-панели центра.
    // Возвращает {has_access: bool, role: 'owner'|'teacher'|'admin'|'none', reason?}.
    // На сетевой ошибке кидаем — вызывающий сам решит, что делать.
    static checkAdminAccess = async () => {
        const response = await axios.get(API_ADMIN_access_check, {
            headers: {
                'Authorization': localStorage.getItem('Authorization')
            }
        });
        return response.data;
    }

    // Bulk-загрузка профилей Майнкрафтии. ids — массив user.id.
    // Возвращает мапу {id: {firstName, photo, level, diamond, rating, _demo}}.
    // Используется на Аккаунты учеников, Прогресс, Проверку проектов.
    static getProfilesBulk = async (ids) => {
        if (!ids || ids.length === 0) return {};
        try {
            const response = await axios.post(API_ADMIN_profiles_bulk,
                { user_ids: ids },
                { headers: { 'Authorization': localStorage.getItem('Authorization') } }
            );
            const map = {};
            (response.data?.profiles || []).forEach(p => {
                if (p && p.id != null) map[p.id] = p;
            });
            return map;
        } catch (e) {
            logger.error('getProfilesBulk error:', e);
            return {};
        }
    }


    // получить данные юзера по id серилизовано
    static async getUserForIdSerialise(idUser) {
        const response = await axios.get(API_USER_get_user_from_id + idUser, {
            headers: {
                'Authorization': localStorage.getItem('Authorization')
            }
        })
        return response.data
    }

    // получить мои алмазы
    static async getMyDiamond() {
        const response = await axios.get(API_USER_get_my_diamond, {
            headers: {
                'Authorization': localStorage.getItem('Authorization') //the token is a variable which holds the token
            }
        })
        return response.data.count
    }

    // получить мой рейтинг
    static async getMyRating() {
        const response = await axios.get(API_USER_get_my_rating, {
            headers: {
                'Authorization': localStorage.getItem('Authorization') //the token is a variable which holds the token
            }
        })

        return response.data.data.rating
    }
    // получить мои достижения
    static async getMyAchievs() {
        const response = await axios.get(API_USER_get_my_rating, {
            headers: {
                'Authorization': localStorage.getItem('Authorization') //the token is a variable which holds the token
            }
        })

        return response.data.data
    }

    // получить чужие данные по таблицу 
    static async getRatingForId(id) {
        const response = await axios.get(API_USER_get_id_rating + id, {
            headers: {
                'Authorization': localStorage.getItem('Authorization') //the token is a variable which holds the token
            }
        })

        return response.data.data
    }

    // получить мою роль
    static async getMyRole() {
        const response = await axios.get(API_USER_get_my_role, {
            headers: {
                'Authorization': localStorage.getItem('Authorization') //the token is a variable which holds the token
            }
        })

        return response.data
    }


    // изменить профиль
    static async putMyProfile(get_res, option) {
        const formData = new FormData();
        if (option.photo) { formData.append("photo", option.photo); }
        formData.append("basicCourse", option.basicCourse);
        formData.append("city", option.city);
        formData.append("country", option.country);
        formData.append("firstName", option.firstName);
        formData.append("lang", option.lang);
        formData.append("lastName", option.lastName);
        formData.append("status", option.status);
        await axios.put(API_USER_put_my_profile, formData, {
            headers: {
                'Authorization': localStorage.getItem('Authorization')
            }
        })
            .then(function (response) {
                get_res(response.data.message)
            })
    }


    // получить лекцию своего основного курса по JWT
    static async getMyLearning() {
        try {
            const response = await axios.get(API_USER_whatLectureNow, {
                headers: {
                    'Authorization': localStorage.getItem('Authorization')
                }
            })
            return response.data.whatLectureNow
        } catch (e) {
            logger.error('UserService request failed:', e?.message || e);
            return undefined;
        }
    }

    // получить мои купленные лекции
    static async getMyBuyLectures(course) {
        try {
            const response = await axios.get(API_USER_learnings_myBuyLectures + course, {
                headers: {
                    'Authorization': localStorage.getItem('Authorization')
                }
            })

            return response.data.buyLectures
        } catch (e) {
            logger.error('UserService request failed:', e?.message || e);
            return undefined;
        }
    }

    // получить мои решенные задачи
    static async getMyAddTasks(course) {
        try {
            const response = await axios.get(API_USER_get_my_task + course, {
                headers: {
                    'Authorization': localStorage.getItem('Authorization')
                }
            })
            return response.data.task
        } catch (e) {
            logger.error('UserService request failed:', e?.message || e);
            return undefined;
        }
    }


    // Купить лекцию по id
    static async BuyLecture(idLecture, course) {
        // logger.log('idLecture = '+idLecture);

        try {
            const formData = new FormData();
            const response = await axios.put(API_USER_learnings_byLecture + idLecture + '/' + course, formData, {
                headers: {
                    'Authorization': localStorage.getItem('Authorization')
                }
            })
            // logger.log(response.data);

            return response.data.message
        } catch (e) {
            logger.error('UserService request failed:', e?.message || e);
            return undefined;
        }

    }



    // платим за решенную задачу
    static async payTask(idTask, course) {
        try {
            const formData = new FormData();
            const response = await axios.put(API_USER_learnings_payTask + idTask + '/' + course, formData, {
                headers: {
                    'Authorization': localStorage.getItem('Authorization')
                }
            })
            // logger.log(response.data.message);

            return response.data.message
        } catch (e) {
            logger.error('UserService request failed:', e?.message || e);
            return undefined;
        }

    }

    // получить всех пользователей сериализовано
    static async getAllUser(page) {
        const response = await axios.get(API_USER_get_all_user + page, {
            headers: {
                'Authorization': localStorage.getItem('Authorization') //the token is a variable which holds the token
            }
        })
        return await response.data
    }
    // получить всех пользователей сериализовано
    static async getProfileData(id) {
        const response = await axios.get(API_USER_profileData + id, {
            headers: {
                'Authorization': localStorage.getItem('Authorization') //the token is a variable which holds the token
            }
        })
        return await response.data
    }


    // получить список моих задач майнклава
    static async getMyTaskMineKlava() {
        const response = await axios.get(API_USER_learnings_myTaskMineKlava, {
            headers: {
                'Authorization': localStorage.getItem('Authorization') //the token is a variable which holds the token
            }
        })
        return await response.data
    }

    // получить список всех заданий по майн клаве без тела
    static async getTasksMineKlava(device) {
        const response = await axios.get(API_USER_learnings_TasksMineKlava + '/' + device, {
            headers: {
                'Authorization': localStorage.getItem('Authorization') //the token is a variable which holds the token
            }
        })
        return await response.data
    }


    // прошел задание в Майн Клаве с учетом устройства
    static async postPayTaskMineKlava(idTask, dataTask, device) {
        try {
            const response = await axios.post(API_USER_learnings_payTaskMineKlava, {
                'idTask': idTask,
                'dataTask': dataTask,
                'device': device
            }, {
                headers: {
                    'Authorization': localStorage.getItem('Authorization') //the token is a variable which holds the token
                }
            });
            return response.data
        } catch (error) {
            logger.log('Ошибка запроса к серверу');
            logger.log(error);
            throw error;
        }
    }

    // Проверка на выполнение задания в курсе по вебу
    static async doneTaskWeb(submitSolution, idTaskWrap) {
        const formData = new FormData();
        formData.append("submitSolution", submitSolution);
        formData.append("idTaskWrap", idTaskWrap);


        try {
            const response = await axios.post(API_USER_learnings_doneTaskWeb, formData, {
                headers: {
                    'Authorization': localStorage.getItem('Authorization')
                }
            })
            return await response.data.result
        } catch (error) {
            logger.log('Ошибка запроса к серверу');
            // logger.log(response.data.error);

        }

    }

    // Проверка на выполнение задания в курсе по вебу без оплаты для хелпа
    static async doneTaskWebNotPay(submitSolution, idTaskWrap) {
        const formData = new FormData();
        formData.append("submitSolution", submitSolution);
        formData.append("idTaskWrap", idTaskWrap);


        try {
            const response = await axios.post(API_USER_learnings_doneTaskWebNotPay, formData, {
                headers: {
                    'Authorization': localStorage.getItem('Authorization')
                }
            })
            return await response.data.result
        } catch (error) {
            logger.log('Ошибка запроса к серверу');
            // logger.log(response.data.error);

        }

    }

    // купить уровень
    static async buyLevel() {
        const response = await axios.get(API_USER_buyLevel, {
            headers: {
                'Authorization': localStorage.getItem('Authorization') //the token is a variable which holds the token
            }
        })
        return await response.data
    }

    // Поиск пользователей по имени1
    static async searchUsers(query) {
        try {
            if (!query || query.trim().length === 0) {
                return { data: [], count: 0, query: '' };
            }

            const response = await axios.get(API_USER_search + encodeURIComponent(query.trim()), {
                headers: {
                    'Authorization': localStorage.getItem('Authorization')
                }
            });

            return response.data;
        } catch (error) {
            logger.error('Ошибка поиска пользователей:', error);
            throw error;
        }
    }

    // Получить данные админского дашборда
    static async getAdminDashboard() {
        try {
            const response = await axios.get(API_USER_admin, {
                headers: {
                    'Authorization': localStorage.getItem('Authorization')
                }
            });
            return response.data;
        } catch (error) {
            logger.error('Ошибка получения данных дашборда:', error);
            throw error;
        }
    }

    // Получить таблицу лидеров с пагинацией
    static async getLeaderboard(page = 1) {
        try {
            const response = await axios.get(API_USER_getLeaderboard + page, {
                headers: {
                    'Authorization': localStorage.getItem('Authorization')
                }
            });
            return response.data;
        } catch (error) {
            logger.error('Ошибка получения таблицы лидеров:', error);
            throw error;
        }
    }

    // Получить историю лидеров прошлых месяцев
    static async getLeadersHistory() {
        try {
            const response = await axios.get(API_USER_getLeadersHistory, {
                headers: {
                    'Authorization': localStorage.getItem('Authorization')
                }
            });
            return response.data;
        } catch (error) {
            logger.error('Ошибка получения истории лидеров:', error);
            throw error;
        }
    }

    // Получить топ-3 лидеров текущего месяца
    static async getTop3Leaders() {
        try {
            const response = await axios.get(API_USER_getTop3Leaders, {
                headers: {
                    'Authorization': localStorage.getItem('Authorization')
                }
            });
            return response.data;
        } catch (error) {
            logger.error('Ошибка получения топ-3 лидеров:', error);
            throw error;
        }
    }

    // Получить статистику текущего месяца
    static async getMonthStats() {
        try {
            const response = await axios.get(API_USER_getMonthStats, {
                headers: {
                    'Authorization': localStorage.getItem('Authorization')
                }
            });
            return response.data;
        } catch (error) {
            logger.error('Ошибка получения статистики месяца:', error);
            throw error;
        }
    }

    // Выдать награду за принятый проект
    static async awardProjectReward(userId, diamonds, rating) {
        try {
            // Получаем ID текущего пользователя (преподавателя) из токена
            const token = localStorage.getItem('Authorization');
            if (!token) {
                throw new Error('Токен авторизации отсутствует');
            }

            const decoded = jwtDecode(token);
            const ownerId = decoded.id;

            const response = await axios.post(`${USER_addres}/api/v1/user/${userId}/award_project_reward`, {
                diamonds: diamonds,
                rating: rating,
                ownerId: ownerId  // Передаем ID преподавателя для безопасности
            }, {
                headers: {
                    'Authorization': localStorage.getItem('Authorization'),
                    'Content-Type': 'application/json'
                }
            });

            return response.data;
        } catch (error) {
            logger.error('Ошибка выдачи награды за проект:', error);

            if (error.response) {
                // Сервер ответил с кодом ошибки
                const { status, data } = error.response;
                if (status === 403) {
                    throw new Error('Нет доступа: можно выдавать награды только своим ученикам');
                }
                throw new Error(data.message || `Ошибка сервера: ${status}`);
            } else if (error.request) {
                throw new Error('Ошибка сети. Проверьте подключение к интернету.');
            } else {
                throw new Error(error.message || 'Неизвестная ошибка при выдаче награды');
            }
        }
    }

    // Получить пользователя по ID (для отображения профиля майнкрафтии)
    static async getUserById(userId) {
        try {
            const response = await axios.get(API_USER_get_user_from_id + userId, {
                headers: {
                    'Authorization': localStorage.getItem('Authorization')
                }
            });

            return response.data;
        } catch (error) {
            logger.error('Ошибка получения пользователя:', error);

            if (error.response) {
                const { status, data } = error.response;
                if (status === 404) {
                    return { success: false, message: 'Пользователь не найден' };
                }
                throw new Error(data.message || `Ошибка сервера: ${status}`);
            } else if (error.request) {
                throw new Error('Ошибка сети. Проверьте подключение к интернету.');
            } else {
                throw new Error(error.message || 'Неизвестная ошибка получения пользователя');
            }
        }
    }

    // Получить статистику заданий Майнкрафтии по списку ID пользователей
    static async getMinecraftTasksStats(userIds) {
        try {
            if (!userIds || !Array.isArray(userIds) || userIds.length === 0) {
                throw new Error('Список user_ids не предоставлен или пуст');
            }

            const response = await axios.post(API_USER_getMinecraftTasksStats, {
                user_ids: userIds
            }, {
                headers: {
                    'Authorization': localStorage.getItem('Authorization'),
                    'Content-Type': 'application/json'
                }
            });

            return response.data;
        } catch (error) {
            logger.error('Ошибка получения статистики заданий Майнкрафтии:', error);

            if (error.response) {
                const { status, data } = error.response;
                if (status === 400) {
                    throw new Error('Неверные параметры запроса: ' + (data.message || 'проверьте список ID пользователей'));
                } else if (status === 404) {
                    throw new Error('Endpoint не найден - обратитесь к разработчику');
                } else if (status === 500) {
                    throw new Error('Внутренняя ошибка сервера: ' + (data.message || 'попробуйте позже'));
                }
                throw new Error(data.message || `Ошибка сервера: ${status}`);
            } else if (error.request) {
                throw new Error('Ошибка сети. Проверьте подключение к интернету.');
            } else {
                throw new Error(error.message || 'Неизвестная ошибка получения статистики');
}
        }
    }


}














